module.exports = __webpack_public_path__ + "static/media/download.455b992e.svg";